<template>
  <div class="loading" v-if="isLoading"></div>
</template>

<script>
  export default {
    name: 'Loading',
    data() {
      return {
        msg: 'Hello Vue!'
      };
    },
    computed: {
      isLoading() {
        return this.$store.state.isLoading;
      }
    },
    mounted() {},
    methods: {},
    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .loading {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0) url('../assets/loading.gif') no-repeat center center;
    background-size: 120px;
    z-index: 666666;
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?bc11de30